module.exports = __webpack_public_path__ + "static/img/android-chrome-192x192.bc575b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/android-chrome-192x192.png
// module id = 410
// module chunks = 1